import { inject } from 'mobx-react';
import * as React from 'react';
import { Route, RouteProps } from 'react-router-dom';
import { IUser } from 'src/Definitions';
import { IStores } from '../../Stores';
import IRoute from '../IRoute';
import RedirectWithErrorMessage from '../RedirectWithErrorMessage';

interface IRoleRequiredRouteProps {
    route: IRoute;
    user?: IUser;
}

const RoleRequiredRoute: React.SFC<IRoleRequiredRouteProps> = (props) => {
    const { route, user } = props;
    const allowedRoles = route.allowedRoles ? route.allowedRoles : [];
    const userRoles = user ? user.roles : [];
    const isInAllowedRole =
        allowedRoles.length === 0 || allowedRoles.some((x: string) => userRoles.indexOf(x) > -1);
    let routeRender: (routeProps: RouteProps) => JSX.Element;
    if (isInAllowedRole) {
        routeRender = (routeProps: RouteProps) => <route.component {...routeProps} />;
    } else {
        routeRender = () => (
            <RedirectWithErrorMessage
                messageId="routeRequiresRole"
                message="Your account is not permitted on that page."
                redirectTo="/"
            />
        );
    }
    return <Route path={route.path} render={routeRender} />;
};

const InjectedRoleRequiredRoute = inject<
    IStores,
    IRoleRequiredRouteProps,
    Partial<IRoleRequiredRouteProps>,
    any
>((stores: IStores) => ({
    user: stores.global.user,
}))(RoleRequiredRoute);

export default InjectedRoleRequiredRoute;



// WEBPACK FOOTER //
// ./src/routing/RoleRequiredRoute/RoleRequiredRoute.tsx